import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { api } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";
import { attachRefreshInterceptor } from "src/utils/axiosRefreshInterceptor";

let instance: AxiosInstance;
let eventInstance: AxiosInstance;

const axiosInstance = async () => {
  instance = axios.create({
    baseURL: api + "/api/v1/feedback",
  });
  // Attach 403 refresh-and-retry interceptor
  attachRefreshInterceptor(instance);

  instance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
};

const axiosEventInstance = async () => {
  eventInstance = axios.create({
    baseURL: api + "/event/feedback",
  });
  // Attach 403 refresh-and-retry interceptor
  attachRefreshInterceptor(eventInstance);

  eventInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
};

axiosEventInstance();

axiosInstance();

export const addFeedback = async (data: any): Promise<AxiosResponse> => {
  return instance.post("/add", data);
};

export const uploadFileToS3 = (data: any) => instance.post("upload-file", data);

